import React from 'react';
import Disputes from '../../../subsreens/gcstaff/myDisputes/Disputes';
import TeacherMasterLayout from '../../../layouts/gcstaff/staffmasterlayout/TeacherMasterLayout';

const DisputesScreen = () => {
    return(
        <TeacherMasterLayout>
            <Disputes/>
        </TeacherMasterLayout>
    )
}

export default DisputesScreen;